export default __webpack_public_path__ + "images/bgpk1.62963d6.jpg";